import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ScreeningCaseCompositeEntity } from '@nk/data-entities-lib';
import { ButtonDirective } from '@nk/ui-lib';
import { DateFormats } from '@nk/utils-lib';
import { normalizeScreeningContext } from '../../utils/screening-case-review-context.utils';
import { SCREENING_STATUS_TAG_CSS_CLASSES, SCREENING_STATUS_TAG_ICONS } from '../../utils/screening-case.utils';
import {
  getScreeningStatusTags,
  SCREENING_STATUS_TAGS_TRANSLATIONS,
  ScreeningStatusTag,
} from '../../utils/screening-overview.utils';

interface ScreeningCaseTableRow {
  uuid: string;
  matchName: string;
  matchScore: number | null;
  date: Date | null;
  screeningStatusTags: ScreeningStatusTag[];
}

@Component({
  selector: 'nk-screening-case-table',
  imports: [DatePipe, TranslateModule, ButtonDirective, RouterLink],
  templateUrl: './screening-case-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreeningCaseTableComponent {
  public screeningEntityUuid = input.required<string>();
  public screeningCaseComposites = input.required<ScreeningCaseCompositeEntity[]>();

  public isPrintVersion = input(false);
  public dateFormats = DateFormats;
  public translations = SCREENING_STATUS_TAGS_TRANSLATIONS;
  public cssClasses = SCREENING_STATUS_TAG_CSS_CLASSES;
  public icons = SCREENING_STATUS_TAG_ICONS;

  public rows = computed<ScreeningCaseTableRow[]>(() => {
    const composites = this.screeningCaseComposites();
    return composites
      .map((composite) => {
        const supplierData = normalizeScreeningContext(composite.screening_case.screening_context);
        return {
          uuid: composite.screening_case.uuid,
          matchName: supplierData[0]?.match_name ?? '-',
          matchScore: supplierData[0]?.match_score ?? null,
          date: composite.screening_case_state?.latest_screening_case_review_update_timestamp ?? null,
          screeningStatusTags: composite.screening_case_state
            ? getScreeningStatusTags(composite.screening_case_state)
            : [],
        };
      })
      .sort((a, b) => {
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(b.date).valueOf() - new Date(a.date).valueOf();
      });
  });
}
